import { Component, Prop, Vue } from 'vue-property-decorator';
import { unique } from '@/helpers/ArrayHelpers';
import { currencySymbol } from '@/helpers/Currency';
import { showAdvertisedFees } from '@/helpers/Fees';
import { languageItem } from '@/language/helpers';
@Component({ name: 'TixLegend' })
export default class TixLegend extends Vue {
    @Prop({ required: true })
    annotations;
    @Prop({ required: true })
    areAnySoldOut;
    @Prop({ required: true })
    arePricesDisplayed;
    @Prop({ required: true })
    hasPriceIncrease;
    t;
    get messageActions() {
        return unique(this.annotations);
    }
    get taxesAndFeesMessage() {
        if (!this.arePricesDisplayed)
            return '';
        return showAdvertisedFees() ? this.t.priceIncludesTax : this.t.priceExcludesTax;
    }
    get currencySymbol() {
        return currencySymbol();
    }
    get hasItems() {
        return this.messageActions.length > 0 || this.areAnySoldOut || this.taxesAndFeesMessage || this.hasPriceIncrease;
    }
    get soldOutLabel() {
        return languageItem('availabilityStatus').soldOut;
    }
}
